import React from "react";

export default function Metaverse() {
  return (
    <div style={{ marginTop: "4rem" }}>
      <iframe src="https://stellar-donut-7119ad.netlify.app/"></iframe>
    </div>
  );
}
